import React from 'react';
import { CheckCircleIcon, RocketIcon, BotIcon, SparklesIcon, TrendingDownIcon, GlobeIcon } from 'lucide-react';
export function ObjectionHandler() {
  return <section id="objection-handler" className="py-12 sm:py-16 md:py-20 bg-orange-50" data-id="element-112">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-113">
        <div className="text-center mb-8 sm:mb-12 md:mb-16" data-id="element-114">
          <div className="inline-flex items-center justify-center w-16 h-16 sm:w-20 sm:h-20 bg-orange-600 rounded-full mb-4 sm:mb-6" data-id="element-115">
            <CheckCircleIcon className="h-8 w-8 sm:h-10 sm:w-10 text-white" data-id="element-116" />
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 sm:mb-4 leading-tight px-2" data-id="element-117">
            5 razones por las que los productos digitales con IA son el camino
            hacia ventas infinitas
          </h2>
        </div>
        <div className="max-w-4xl mx-auto space-y-4 sm:space-y-6" data-id="element-118">
          <div className="bg-white p-5 sm:p-6 md:p-8 rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300" data-id="element-119">
            <div className="flex items-start gap-3 sm:gap-4 mb-3 sm:mb-4" data-id="element-120">
              <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 bg-orange-100 rounded-lg flex items-center justify-center" data-id="element-121">
                <RocketIcon className="h-5 w-5 sm:h-6 sm:w-6 text-orange-700" data-id="element-122" />
              </div>
              <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-orange-700 leading-tight" data-id="element-123">
                Escalabilidad ilimitada
              </h3>
            </div>
            <p className="text-base sm:text-lg text-gray-700 leading-relaxed pl-0 sm:pl-16" data-id="element-124">
              Un producto digital no requiere inventario físico. Puedes venderlo
              1 vez o 1 millón de veces sin costos adicionales por unidad.
            </p>
          </div>
          <div className="bg-white p-5 sm:p-6 md:p-8 rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300" data-id="element-125">
            <div className="flex items-start gap-3 sm:gap-4 mb-3 sm:mb-4" data-id="element-126">
              <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 bg-orange-100 rounded-lg flex items-center justify-center" data-id="element-127">
                <BotIcon className="h-5 w-5 sm:h-6 sm:w-6 text-orange-700" data-id="element-128" />
              </div>
              <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-orange-700 leading-tight" data-id="element-129">
                Automatización total con IA
              </h3>
            </div>
            <p className="text-base sm:text-lg text-gray-700 leading-relaxed pl-0 sm:pl-16" data-id="element-130">
              Puedes usar IA para automatizar atención al cliente, marketing,
              ventas, soporte técnico y seguimiento postventa.
            </p>
          </div>
          <div className="bg-white p-5 sm:p-6 md:p-8 rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300" data-id="element-131">
            <div className="flex items-start gap-3 sm:gap-4 mb-3 sm:mb-4" data-id="element-132">
              <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 bg-orange-100 rounded-lg flex items-center justify-center" data-id="element-133">
                <SparklesIcon className="h-5 w-5 sm:h-6 sm:w-6 text-orange-700" data-id="element-134" />
              </div>
              <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-orange-700 leading-tight" data-id="element-135">
                Personalización masiva sin esfuerzo
              </h3>
            </div>
            <p className="text-base sm:text-lg text-gray-700 leading-relaxed pl-0 sm:pl-16" data-id="element-136">
              Gracias a la IA, puedes ofrecer experiencias personalizadas para
              cada cliente, aumentando la conversión sin intervención humana
              directa.
            </p>
          </div>
          <div className="bg-white p-5 sm:p-6 md:p-8 rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300" data-id="element-137">
            <div className="flex items-start gap-3 sm:gap-4 mb-3 sm:mb-4" data-id="element-138">
              <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 bg-orange-100 rounded-lg flex items-center justify-center" data-id="element-139">
                <TrendingDownIcon className="h-5 w-5 sm:h-6 sm:w-6 text-orange-700" data-id="element-140" />
              </div>
              <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-orange-700 leading-tight" data-id="element-141">
                Costos operativos mínimos
              </h3>
            </div>
            <p className="text-base sm:text-lg text-gray-700 leading-relaxed pl-0 sm:pl-16" data-id="element-142">
              Al ser digital y automatizado, puedes operar con márgenes
              altísimos y pocos (o ningún) empleados.
            </p>
          </div>
          <div className="bg-white p-5 sm:p-6 md:p-8 rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300" data-id="element-143">
            <div className="flex items-start gap-3 sm:gap-4 mb-3 sm:mb-4" data-id="element-144">
              <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 bg-orange-100 rounded-lg flex items-center justify-center" data-id="element-145">
                <GlobeIcon className="h-5 w-5 sm:h-6 sm:w-6 text-orange-700" data-id="element-146" />
              </div>
              <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-orange-700 leading-tight" data-id="element-147">
                Acceso global 24/7
              </h3>
            </div>
            <p className="text-base sm:text-lg text-gray-700 leading-relaxed pl-0 sm:pl-16" data-id="element-148">
              Tu producto está disponible en todo el mundo, todos los días del
              año, incluso mientras duermes.
            </p>
          </div>
        </div>
      </div>
    </section>;
}